import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitleUpdater = ({ defaultTitle }) => {
  const location = useLocation();

  useEffect(() => {
    let title = defaultTitle;
    if (location.pathname === '/') {
      title = `Work - ${defaultTitle}`;
    } else if (location.pathname.startsWith('/profile')) {
      title = `Profile - ${defaultTitle}`;
    } else if (location.pathname.startsWith('/work')) {
      title = `Work - ${defaultTitle}`;
    }
    document.title = title;
  }, [location, defaultTitle]);

  return null; // This component does not render anything
};

export default PageTitleUpdater;
